import React, { useEffect, useState } from "react";
import close from "../../assets/icons/close.svg";
import { getData, Postdata, Postdataform, PostFileData } from "../../API/GlobalApi";
import Notifier from "../../Utils/notify";
import '../../assets/css/Modal.css';
import { createPortal } from "react-dom";
import { reactSelectStyles } from "../../Utils/selectBoxStyle";
import Select from 'react-select'
export const ExceptionalApprovalModal = ({ isOpen, onClose, selectedDetails, onUploadSuccess, activityId }) => {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);


    const [helpdeskperson, setHelpDeskPerson] = useState([]);
    const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]); // now an array


    const gethelpdeskPerson = async () => {
        const url = "finance/course-fee-plans/authorized-employees/?type=impose";
        const response = await getData(url);
        setHelpDeskPerson(response?.authorized_employees)

    }
 useEffect(() => {
    if (isOpen) {
        gethelpdeskPerson();
    }
}, [isOpen]);


    if (!isOpen) return null;

    const handleSubmit = async () => {
        if (!file) {
            Notifier.error("Please upload a file");
            return;
        }
        if (!selectedEmployeeIds.length) {
            Notifier.error("Please select at least one authorized person");
            return;
        }

        try {
            setLoading(true);

            const formData = new FormData();
            formData.append("document_url", file);
            formData.append("student_id", selectedDetails?.student_id);
            formData.append("activity_id", activityId);
            formData.append("employee_ids", selectedEmployeeIds.join(","));
            const Url = `${process.env.REACT_APP_WINDOW_BASEURL2}activity/exceptional-fee-due-approvals/`;
            formData.append("approval_link", Url);


            const res = await Postdataform("academics/activities/exceptional-approval/", formData);

            if (!res?.error) {
                Notifier.success("Exceptional approval uploaded successfully");

                // Reset states
                setFile(null);
                setSelectedEmployeeIds([]);

                // Notify parent
                onUploadSuccess?.();

                // Close modal
                onClose();
            } else {
                Notifier.error(res?.error || "Failed to upload file");
            }
        } catch (err) {
            console.error(err);
            Notifier.error("Something went wrong");
        } finally {
            setLoading(false); // only stop loading here
        }

    };



    return (
        <div className="modal-overlay">
            <div
                className="modal-content recevingPaymentBody"
                style={{
                    position: "relative",
                    width: "32%",
                    display: "flex",
                    flexDirection: "column",
                    overflowY: "auto",
                    minHeight: "45vh",
                    padding: "22px",
                }}
            >
                {/* Header */}
                <div
                    className="modal-header-content"
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                    }}
                >
                    <h2 className="text-primary">Exceptional Approval</h2>
                    <button className="close-btn" onClick={onClose}>
                        <img src={close} alt="close" />
                    </button>
                </div>

                {/* Body */}
                <div style={{ flex: 1 }}>
                    <div className="mb-3">
                        <label className="form-labell">Upload File</label>
                        <input
                            type="file"
                            className="form-control"
                            accept="image/*"        // ✅ Accept only images
                            onChange={(e) => setFile(e.target.files[0])}
                        />

                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <label className="form-labell mb-2">
                                Authorised Person<span className="astrisk">*</span>
                            </label>

                            <Select
                                classNamePrefix="select"
                                isSearchable
                                isMulti                        // <-- enable multi-select
                                name="employee"
                                options={helpdeskperson?.map(emp => ({
                                    value: emp.id,
                                    label: emp.name,
                                }))}
                                placeholder="-- Select Employee --"
                                value={helpdeskperson
                                    ?.map(emp => ({
                                        value: emp.id,
                                        label: emp.name,
                                    }))
                                    .filter(option => selectedEmployeeIds?.includes(option.value))}  // <-- filter selected
                                onChange={(selected) => setSelectedEmployeeIds(selected?.map(s => s.value) || [])} // store array of ids
                                menuPortalTarget={document.body}
                                styles={{
                                    ...reactSelectStyles,

                                }}

                                menuPlacement="auto"
                            // menuPosition="absolute"
                            />

                        </div>

                    </div>
                </div>

                {/* Footer */}
                <div style={{ display: "flex", justifyContent: "end" }}>
                    <button
                        className="add-btn"
                        style={{
                            padding: "10px 20px",
                            backgroundColor: file ? "#7F56DA" : "#d3d3d3",
                            cursor: file ? "pointer" : "not-allowed",
                        }}
                        disabled={loading || !file}
                        onClick={handleSubmit}
                    >
                        {loading ? <span className="spinner-border spinner-border-sm" role="status" /> : "Upload"}
                    </button>
                </div>
            </div>
        </div>

    );
};
